import { render, staticRenderFns } from "./Quarantine.vue?vue&type=template&id=6d9749a3&"
import script from "./Quarantine.vue?vue&type=script&lang=js&"
export * from "./Quarantine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports